import React, { useState } from "react";
import axios from "axios";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
const testURL = process.env.REACT_APP_TEST_URL;
const productionURL = process.env.REACT_APP_PRODUCTION_URL;
const TicketModal = ({ ticket, onClose }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [actionDetails, setActionDetails] = useState([]);
  const [isActionModalOpen, setActionModalOpen] = useState(false);

  if (!ticket) return null;

  // Handle image click for lightbox
  const handleImageClick = (url) => {
    setLightboxImages([{ src: url }]);
    setLightboxOpen(true);
  };

  // Fetch action details when button is clicked
  const fetchActionDetails = async () => {
    try {
      const response = await axios.get(productionURL + `/api/ondc/getActions/${ticket.ticketId}`);
      setActionDetails(response.data);
      setActionModalOpen(true);
    } catch (error) {
      console.error("Error fetching action details:", error);
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target.classList.contains("modal-overlay") && onClose()}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>✖</button>
        <h2>Ticket Details</h2>

        <table className="ticket-table">
          <tbody>
            {Object.entries(ticket)
              .filter(([key]) => key !== "listActions") // Exclude listActions
              .map(([key, value]) => (
                <tr key={key}>
                  <td className="label">{key.replace(/([A-Z])/g, " $1")}</td>
                  <td className="value">{value || "N/A"}</td>
                </tr>
              ))}
          </tbody>
        </table>

        {/* Supporting Media Section */}
        {ticket.supportingMedia && (
          <div className="media-section">
            <h3>Supporting Media</h3>
            <div className="media-container">
              {ticket.supportingMedia.split(",").map((url, index) => {
                const isPdf = url.toLowerCase().endsWith(".pdf");

                return (
                  <div key={index} className="media-item">
                    {isPdf ? (
                      <a href={url} target="_blank" rel="noopener noreferrer" className="pdf-link">
                        View PDF {index + 1}
                      </a>
                    ) : (
                      <img
                        src={url}
                        alt={`Support Image ${index + 1}`}
                        className="media-thumbnail"
                        onClick={() => handleImageClick(url)}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ✅ Button for Action Details */}
        <button className="action-button" onClick={fetchActionDetails}>Click Here for Action Details</button>

        {/* Lightbox Viewer */}
        {lightboxOpen && (
          <Lightbox
            slides={lightboxImages}
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
          />
        )}

        {/* Action Details Modal */}
        {isActionModalOpen && (
          <div className="modal-overlay" onClick={() => setActionModalOpen(false)}>
            <div className="modal-content large-modal" onClick={(e) => e.stopPropagation()}>
              <button className="close-button" onClick={() => setActionModalOpen(false)}>✖</button>
              <h2>Action Details</h2>
              <div className="table-wrapper">
                <table className="ticket-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Action ID</th>
                      <th>Code</th>
                      <th>Action By</th>
                      <th>Description</th>
                      <th>Actor Name</th>
                      <th>Updated At</th>
                      <th>Issue ID</th>
                      <th>Counter Party ID</th>
                      <th>Counter Party Name</th>
                      <th>Counter Party Contact</th>
                      <th>Counter Party Email</th>
                      <th>Description Name</th>
                      <th>Additional Images</th>
                      <th>REFID</th>
                      <th>REFTYPE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {actionDetails.length > 0 ? (
                      actionDetails.map((action) => (
                        <tr key={action.id}>
                          <td>{action.id}</td>
                          <td>{action.actionId}</td>
                          <td>{action.code}</td>
                          <td>{action.actionBy}</td>
                          <td>{action.shortDescription}</td>
                          <td>{action.actorName}</td>
                          <td>{new Date(action.updatedAt).toLocaleString()}</td>
                          <td>{action.issueId}</td>
                          <td>{action.counterPartyId || "N/A"}</td>
                          <td>{action.counterPartyPersonName || "N/A"}</td>
                          <td>{action.counterPartyPersonContactNo || "N/A"}</td>
                          <td>{action.counterPartyPersonEmail || "N/A"}</td>
                          <td>{action.descriptionName || "N/A"}</td>
                          <td>{action.additionalImages || "N/A"}</td>
                          <td>{action.refId || "N/A"}</td>
                          <td>{action.refType || "N/A"}</td>

                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="13">No Actions Found</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketModal;
